import { Stack, Box, Heading, Text, Tiles } from 'braid-design-system';
import React from 'react';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import Section from 'src/views/Franchise/components/Section/Section';

interface ItemProps {
  text: string;
  link: string;
}

const Item = (props: ItemProps) => (
  <Box
    background="surface"
    borderRadius="standard"
    padding="small"
    height="full"
    width="full"
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Text size="small" align="center">
      <ExternalLink
        destination={`/businesses-for-sale/only-franchises/${props.link}`}
      >
        {props.text}
      </ExternalLink>
    </Text>
  </Box>
);

const ByIndustry = () => (
  <Stack space="small">
    <Text size="small">By industry...</Text>
    <Tiles columns={[2, 6]} space="small">
      <Item text="Food &amp; Drink" link="within-food-and-drink" />
      <Item
        text="Health, Beauty &amp; Fitness"
        link="within-health-beauty-fitness"
      />
      <Item text="Retail" link="within-retail" />
      <Item text="Commercial Services" link="within-commercial-services" />
      <Item text="Personal Services" link="within-personal-services" />
      <Item
        text="Cleaning &amp; Maintenance"
        link="within-cleaning-and-maintenance"
      />
    </Tiles>
  </Stack>
);

const ByLocation = () => (
  <Stack space="small">
    <Text size="small">Or location...</Text>
    <Tiles columns={[1, 4]} space="small">
      <Tiles columns={2} space="small">
        <Item text="Melbourne" link="in-melbourne-vic" />
        <Item text="Sydney" link="in-sydney-nsw" />
      </Tiles>
      <Tiles columns={2} space="small">
        <Item text="Brisbane" link="in-brisbane-qld" />
        <Item text="Perth" link="in-perth-wa" />
      </Tiles>
      <Tiles columns={2} space="small">
        <Item text="Adelaide" link="in-adelaide-sa" />
        <Item text="Hobart" link="in-hobart-tas" />
      </Tiles>
      <Tiles columns={2} space="small">
        <Item text="Darwin" link="in-darwin-nt" />
        <Item text="Canberra" link="in-act-act" />
      </Tiles>
    </Tiles>
  </Stack>
);

const FindAFranchiseOpp = () => (
  <Section>
    <Stack space="large">
      <Heading level="2">Find a franchise opportunity</Heading>
      <ByIndustry />
      <ByLocation />
    </Stack>
  </Section>
);

export default FindAFranchiseOpp;
